import { ArtistProps } from '../types'

type EventCtaOverride = {
  title: string
  url: string
}

export const getEventCtaPrimaryOverride = (artist: ArtistProps): EventCtaOverride => {
  const { shouldOverridePrimaryCta, ctaPrimaryTitleOverride = '', ctaPrimaryUrlOverride = '' } = artist || {}

  return {
    title: shouldOverridePrimaryCta ? ctaPrimaryTitleOverride : '',
    url: shouldOverridePrimaryCta ? ctaPrimaryUrlOverride : ''
  }
}
